import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specialitati-medicale',
  templateUrl: './specialitati-medicale.component.html',
  styleUrls: ['./specialitati-medicale.component.scss']
})
export class SpecialitatiMedicaleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
